import * as React from "react";
import { useParams } from "react-router";
import BlueprintContainer from "../../../components/Blueprints/BlueprintContainer";
import {
  OverviewTitle,
  OverviewTitleWrapper,
} from "../../../components/Details/OverviewInfo/styles";
import {
  DetailInnerWrapper,
  DetailPageBox,
} from "../../../components/sharedStyles";
import { buildQueryString } from "../../../store/base";
import { useFilteredBlueprints } from "../../../store/blueprints";
import { useFilteredRooms } from "../../../store/rooms";
import PageSlider from "../../Layouts/PageSlider/PageSlider";
import PremisesImageContainer from "../../../components/Details/Images/PremisesImageContainer";
import { useCommonArea } from "../../../store/commonAreas";
import { BLUEPRINT_PREMISE_OPTIONS } from "../../../components/Blueprints/BlueprintDisplay/Controller";

const TABS = {
  BLUEPRINT: "Planritning",
  IMAGES: "Bilder",
};

export default function CommonAreaImagesAndBlueprints() {
  const { commonAreaId } = useParams();
  const [selectedTab, setSelectedTab] = React.useState("BLUEPRINT");

  const [commonArea] = useCommonArea(commonAreaId);

  const commonAreaQuery = buildQueryString({
    common_area: commonArea?.id,
  });

  const [blueprints, blueprintsLoading] =
    useFilteredBlueprints(commonAreaQuery);
  const blueprint = blueprints?.[0] || undefined;

  const roomQuery = blueprint
    ? buildQueryString({ blueprint__id: blueprint.id })
    : null;

  const [rooms, roomsLoading] = useFilteredRooms(roomQuery);

  return (
    <DetailInnerWrapper>
      <DetailPageBox>
        <OverviewTitleWrapper>
          <OverviewTitle>{TABS[selectedTab]}</OverviewTitle>

          <PageSlider
            {...{
              TABS,
              selectedTab,
              onTabSelected: (tab) => setSelectedTab(tab),
            }}
          />
        </OverviewTitleWrapper>

        {selectedTab === "BLUEPRINT" && (
          <BlueprintContainer
            blueprint={blueprint}
            premises={commonArea}
            rooms={rooms || []}
            premisesType={BLUEPRINT_PREMISE_OPTIONS.COMMON_AREA}
          />
        )}

        {selectedTab === "IMAGES" && (
          <PremisesImageContainer
            images={commonArea?.images}
            instance={commonArea}
            kind="commonarea"
          />
        )}
      </DetailPageBox>
    </DetailInnerWrapper>
  );
}
